<template>
  <div class="blockuser" v-if="seen" @click="remove">
    <div class="notify">
      <div v-if="loader">
        <span>
          <svg width="120px" height="120px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid" class="lds-dual-ring"
            style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
            <circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed"
              stroke-dasharray="31.41592653589793 31.41592653589793">
              <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
                keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
            </circle>
          </svg>
        </span><br>
        <span>Please wait....</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      click: false,
      seen: false,
      loader: true
    }
  },
  methods: {
    load(click = false) {
      this.click = click
      this.seen = true
    },
    remove() {
      this.seen = false
    },
    close() {
      this.seen = false
    }
  }
}
</script>
